/* Uses normal Shopify search for locales unsupported by predictive search. */
(() => {
  if (window.catalogInstantReady) return;
  window.catalogInstantReady = true;
  function init(root) {
    if (root.dataset.instantReady) return;
    root.dataset.instantReady = 'true';
    const input = root.querySelector('input[type="search"]');
    const form = root.querySelector('form');
    const results = root.querySelector('[data-predictive-search-results]');
    const strings = JSON.parse(root.querySelector('[data-instant-strings]').textContent);
    let timer, controller, version = 0, composing = false;
    const cancel = () => { clearTimeout(timer); controller?.abort(); controller = null; version++; };
    const clear = () => {
      cancel();
      results.replaceChildren(); results.style.display = 'none';
      results.removeAttribute('aria-busy'); input.setAttribute('aria-expanded', 'false');
    };
    const urlFor = (term) => {
      const url = new URL(form.action, location.origin);
      url.searchParams.set('q', term.toLowerCase() === 'fusion' ? 'title:Fusion' : term);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      return url;
    };
    const show = () => {
      root.classList.add('is-active');
      results.style.display = 'block'; input.setAttribute('aria-expanded', 'true');
    };
    const notice = (text, term) => {
      const box = document.createElement('div'); box.className = 'catalog-instant';
      const message = document.createElement('p'); message.setAttribute('role', 'status'); message.textContent = text;
      const all = document.createElement('a'); all.className = 'catalog-instant__all'; all.href = urlFor(term).href; all.textContent = strings.view_all;
      box.append(message, all); results.replaceChildren(box); show();
    };
    async function search(term, requestVersion) {
      const current = new AbortController(); controller = current;
      const timeout = setTimeout(() => current.abort(), 12000);
      try {
        const url = urlFor(term); url.searchParams.set('section_id', 'catalog-instant-results');
        const response = await fetch(url, {credentials: 'same-origin', signal: current.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fragment = doc.querySelector('[data-instant-response]');
        if (!fragment || fragment.textContent.includes('Liquid error')) throw new Error('Invalid search response');
        if (requestVersion !== version || input.value.trim() !== term) return;
        fragment.querySelectorAll('article[data-context]').forEach(card => {
          // Native fallback cards may use a default context for unisex accessories.
          if (!card.hasAttribute('data-r52-card')) return;
          const label = strings[card.dataset.context];
          if (!label) return;
          const caption = document.createElement('span'); caption.className = 'catalog-instant__audience'; caption.textContent = label;
          card.querySelector('h2')?.before(caption);
        });
        results.replaceChildren(fragment); show();
      } catch (error) {
        if (requestVersion === version && input.value.trim() === term) notice(strings.error, term);
      } finally {
        clearTimeout(timeout);
        if (requestVersion === version) { results.removeAttribute('aria-busy'); controller = null; }
      }
    }
    function schedule() {
      cancel();
      const term = input.value.trim();
      if (composing || !term) { clear(); return; }
      const requestVersion = version;
      notice(strings.loading, term); results.setAttribute('aria-busy', 'true');
      timer = setTimeout(() => search(term, requestVersion), 300);
    }
    input.addEventListener('compositionstart', () => { composing = true; clear(); });
    input.addEventListener('compositionend', () => { composing = false; schedule(); });
    input.addEventListener('input', () => { if (!composing) schedule(); });
    input.addEventListener('search', () => { if (!input.value.trim()) clear(); });
    input.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown' && results.childElementCount) { event.preventDefault(); results.querySelector('a')?.focus(); }
    });
    root.addEventListener('keydown', event => {
      if (event.key === 'ArrowUp' && event.target === results.querySelector('a')) { event.preventDefault(); input.focus(); }
    });
    form.addEventListener('submit', () => cancel());
    document.addEventListener('predictive-search:close-all', clear);
    document.addEventListener('predictive-search:close', clear);
    // Motion's native modal still owns opening, closing, Escape and focus trapping.
    new MutationObserver(() => { if (!root.classList.contains('is-active')) clear(); }).observe(root, {attributes: true, attributeFilter: ['class']});
  }
  const scan = () => document.querySelectorAll('[data-catalog-instant]').forEach(init);
  scan(); document.addEventListener('shopify:section:load', scan);
})();
